import { useState } from "react";

export const useFormFields = (initialState?: any) => {
	const [fields, setValues] = useState(initialState);

	const handleFieldChange = (event: any) => {
		if(!event.target.id)return;
		setValues({
			...fields,
			[event.target.id]: event.target.value,
		});
	};

	const resetFields = (initialState: any) => {
		if(!initialState)return;
		setValues(initialState);
	}

	return [fields, handleFieldChange, resetFields];
};
